import { useEffect } from "react";

/**
 * Updates page title and meta description for SEO.
 * Restores the original title on unmount.
 */
export function usePageMeta(
  title: string,
  description?: string
) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    const originalContent = metaDesc?.getAttribute("content") || "";

    if (description) {
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);
    }

    return () => {
      document.title = originalTitle;
      if (metaDesc && description) {
        metaDesc.setAttribute("content", originalContent);
      }
    };
  }, [title, description]);
}